<div class="container">
  <h2>Account request cancelled...</h2>
  <div>(or the request has previously been cancelled, verified or timed out...)</div>
  <div>Thank you for your time.</div>
  <div class="italic">(And if the account registration email had been sent to you in error, we apologize for the inconvenience...)</div>
</div>
